package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordDiagnosisDiagnosisSource
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer

@Serializable
open class MedicalRecordDiagnosis(var id: String? = null){
	var medicalRecordId: String? = null
	var syndromeIndicationId: String? = null
	var diagnosisSource: MedicalRecordDiagnosisDiagnosisSource? = null
	var createdBy: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as MedicalRecordDiagnosis
		if (id != other.id) return false
		if (medicalRecordId != other.medicalRecordId) return false
		if (syndromeIndicationId != other.syndromeIndicationId) return false
		if (diagnosisSource != other.diagnosisSource) return false
		if (createdBy != other.createdBy) return false
		if (createdOn != other.createdOn) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (medicalRecordId?.hashCode() ?: 0)
		result = 31 * result + (syndromeIndicationId?.hashCode() ?: 0)
		result = 31 * result + (diagnosisSource?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		return result
	}

}
